<template>
  <div class="row">
    <InitRecordRemind v-if="records.length===0" :name="name" class="col s12 grey-text lighten-5" />

    <table v-else>
      <thead>
        <tr>
          <th>Skill</th>
          <th>Current</th>
          <th>Target</th>
          <th>Gap%</th>
          <th>Stats</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="record in records" :key="record.skill">
          <td>{{ record.name }}</td>
          <td><span v-if="record.unit!=='time'">{{ record.value }}</span><span v-if="record.unit=='time'">{{ record.valueMinutes }}'{{ record.valueSeconds }}''</span></td>
          <td>
            <span v-if="record.unit!=='time'">{{ record.target}}</span>
            <span v-if="record.unit=='time'">{{ record.target['minutes']}}'{{ record.target.seconds}}''</span>
          </td>
          <td><span v-if="record.gap>0">{{ record.gap }}%</span><i v-if="record.gap<=0" class="material-icons">done</i></td>
          <td><router-link :to="{ name: 'RecordLog', params: { skill: record.skill }}"><i class="material-icons">insert_chart</i></router-link></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import M from 'materialize-css'
import InitRecordRemind from '@/components/cards/InitRecordRemind'
export default {
  name: 'targetList',
  props: {
    'user': Object
  },
  components: { InitRecordRemind },
  data: function () {
    return {
      records: [],
      name: undefined
    }
  },
  created () {
    this.name = this.user.athlete.name

    /* eslint no-unused-vars : 0 */
    const user = this.user // user variable scope for target formula

    // sort records as array based on the name structure eg. 1RM-Squat
    this.records = Object.values(this.user.athlete.records).sort((a, b) => {
      const extract = function (fullname) {
        const s = fullname.split('-')
        if (s.length === 1) return {group: s[0]}
        return {group: s[1], name: s[0]}
      }
      const aSkill = extract(a.skill)
      const bSkill = extract(b.skill)
      if (aSkill.group === bSkill.group) {
        return (aSkill.name > bSkill.name) ? 1 : -1
      } else {
        return aSkill.group > bSkill.group ? 1 : -1
      }
    })

    // compute the targets
    for (var i in this.records) {
    /* eslint no-eval: 0 */
      this.records[i].target = (eval(this.records[i].targetFormula))
      if (this.records[i].unit === 'time') {
        var elapseInSec = this.records[i].valueMinutes * 60 + this.records[i].valueSeconds
        var targetElapseInSec = this.records[i].target.minutes * 60 + this.records[i].target.seconds
        this.records[i].gap = (((elapseInSec - targetElapseInSec) / targetElapseInSec) * 100).toFixed(1)
      } else {
        this.records[i].target = this.records[i].target.toFixed(0)
        this.records[i].gap = (((this.records[i].target - this.records[i].value) / this.records[i].value) * 100).toFixed(1)
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/records/PerformanceList.vue